import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/xc/dev/digimaker-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Delete from './Delete';
import { ActionsRender } from '../ActionsRender';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "use-actions"
    }}>{`Use Actions`}</h1>
    <p>{`Here is rendering actions(shown as icons/buttons first) in `}<inlineCode parentName="p">{`Main`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {ActionsRender} from 'digimaker-ui';

//...
// actionsConfig is a list of actions, supporting component and link
<ActionsRender
    actionProps={{
        from: content,
        params: {
            content: content,
            afterAction: (redirect: boolean) =>
                afterAction(redirect),
        } as ContentActionParams,
        fromview: "content",
    }}
    actionsConfig={mainConfig.actions}
/>
//...
`}</code></pre>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <p>{`Here are properties of `}<inlineCode parentName="p">{`ActionsRender`}</inlineCode></p>
    <Props table={true} of={ActionsRender} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      